import config from '../../../configuration/configuration.js';
import AxiosRequest from '../../../utils/AxiosRequest';

export const GetDataIntegrityFilters = () =>
	AxiosRequest({
		method: 'GET',
		url: `${config.API_URL}DataIntegrity/filters`,
	});

export const PostDataIntegrityFiltersForTable = (dto) =>
	AxiosRequest({
		method: 'POST',
		url: `${config.API_URL}DataIntegrity/filters/cascade`,
		data: dto,
	});

export const PostDataIntegrityData = (dto) =>
	AxiosRequest({
		method: 'POST',
		url: `${config.API_URL}DataIntegrity/data`,
		data: dto,
	});